import { useHook, useMutationHook } from '../utils/use-hook'
import { mutationFetcher } from '../utils/default-fetcher'
import type { HookFetcherFn, MutationHook } from '../utils/types'
import type { UpdateDiscountHook } from '../types/cart'
import type { Provider } from '..'

export type UseUpdateDiscount<
  H extends MutationHook<UpdateDiscountHook<any>> = MutationHook<UpdateDiscountHook>
> = ReturnType<H['useHook']>

export const fetcher: HookFetcherFn<UpdateDiscountHook> = mutationFetcher

const fn = (provider: Provider) => provider.actualCart?.useUpdateDiscount!

const useUpdateDiscount: UseUpdateDiscount = (...args) => {
  const hook = useHook(fn)
  return useMutationHook({ fetcher, ...hook })(...args)
}

export default useUpdateDiscount
